import { capitaliseFirstLetter } from '../lib/utils';
import { generateListItemsGA4 } from './ga_generate_items';

export const listItemsEventsUA = ({ event, options }) => {
  if (!window.dataLayer) return;

  // Clear the previous ecommerce object
  window.dataLayer.push({ ecommerce: null });

  if (event === 'productImpressions') {
    // Search, Category, Brand Page
    const { products, prices, page } = options;

    window.dataLayer.push({
      event,
      ecommerce: {
        currencyCode: 'GBP',
        impressions: products.map(
          (
            {
              stock_code: stockCode,
              brand,
              brand_and_description_short: name,
              id,
              primary_root_category: category,
            },
            index,
          ) => ({
            id: stockCode,
            brand,
            name,
            position: 1 + index,
            price: prices[id].price,
            list: `${capitaliseFirstLetter(page)} Page`,
            category,
            'id-variant': id,
          }),
        ),
      },
    });
  }
};

export const listItemsEventsGA4 = ({ event, options }) => {
  if (!window.dataLayer) return;

  // Clear the previous ecommerce object
  window.dataLayer.push({ ecommerce: null });

  if (event === 'view_item_list_ga4') {
    // Event is used on pages: Search, Category, Brand
    const { products, prices, page } = options;

    window.dataLayer.push({
      event: 'view_item_list_ga4',
      ecommerce: {
        items: generateListItemsGA4(page, products, prices),
      },
    });
  }
};

export const selectItemEventGA4 = ({ event, options }) => {
  if (!window.dataLayer) return;

  // Clear the previous ecommerce object
  window.dataLayer.push({ ecommerce: null });

  if (event === 'select_item_ga4') {
    const { product, page, prices } = options;

    window.dataLayer.push({
      event,
      ecommerce: {
        items: generateListItemsGA4(page, [product], prices),
      },
    });
  }
};
